export const locales = [
    'en',
    'ru',
    'uk',
    'vi',
    'tr',
    'es',
    'pt',
    'zh',
    'zh-TW',
];
/**
 * Maps a BCP 47 tag ("ru-RU", "PT", "zh-Hant-HK") to a supported interface
 * locale. Chinese resolves by script: Traditional tags ("zh-Hant", "zh-TW",
 * "zh-HK", "zh-MO") become "zh-TW", everything else ("zh", "zh-CN",
 * "zh-Hans-TW", "zh-SG") becomes Simplified "zh".
 */
export const parseLocale = (tag) => {
    const parts = (tag ?? '').toLowerCase().split(/[-_]/);
    if (parts[0] === 'zh') {
        if (parts.includes('hans')) {
            return 'zh';
        }
        return parts.some((part) => ['hant', 'tw', 'hk', 'mo'].includes(part))
            ? 'zh-TW'
            : 'zh';
    }
    return locales.find((locale) => locale === parts[0]);
};
export const defaultUserMetadata = {
    onboardingFlow: {
        allowed: false,
        extensionSent: true,
        mobileAppSent: true,
        language: null,
    },
    rate: {
        ios: undefined,
        android: undefined,
        chromeExtension: undefined,
        edgeExtension: undefined,
        safariExtension: undefined,
    },
    lastUpdated: 0,
};
export const mergeUserMetadata = (md1, md2) => {
    return {
        ...md1,
        ...md2,
        rate: {
            ...md1.rate,
            ...md2.rate,
        },
        onboardingFlow: {
            ...md1.onboardingFlow,
            ...md2.onboardingFlow,
        },
    };
};
export const mapUserMetadata = (metadata) => {
    return mergeUserMetadata(defaultUserMetadata, metadata);
};
